<template>
  <div class="mainElemetManagementContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn">
          {{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i>
        </el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="historyTaskTableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
       <el-table-column
          v-for="taskItem in historyTaskTableColumnLists"
          :key="taskItem.prop"
          :prop="taskItem.prop"
          :label="taskItem.label"
          :min-width="taskItem.minWidth"
          :align="taskItem.align"
          :show-overflow-tooltip="taskItem.showOverflowTooltip"
        ></el-table-column>

        <el-table-column
          label="操作"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
                <el-button
                  @click="seeDetailHandle(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >查看详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="text-align:right; margin-top:15px; margin-right:0px; height: 40px;"
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        />
      </div>
    </div>

    <!-- 查看详情 模态框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="1198px"
      class="commonDialog"
      @close="closeDetailHandle"
    >
      <div class="taskContent" v-if="dialogVisiblefirst">
        <div class="leftTask">
          <div class="taskTitle">
            <div class="taskIcon">
              <img :src="taskIcon" class="icon" />
            </div>
            <div class="taskInfo">
              <div class="descOfNo">
                任务编号：<span>{{ singleHistoryTaskData.local_id}} </span>
              </div>
              <div class="line"></div>
              <div class="otherTaskInfo">
                <span>创建时间：{{ singleHistoryTaskData.created_at}}</span>
                <span>提交ID：{{ singleHistoryTaskData.user_no }}</span>
              </div>
            </div>
          </div>

          <div class="taskContentLeft">
            <div class="taskInfoBox taskName">
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    任务名称：
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="singleHistoryTaskData.mission_name"
                      placement="top"
                      :disabled="singleHistoryTaskData.mission_name.length <= 11"
                    >
                      <span> {{ singleHistoryTaskData.mission_name.length > 11 ?  singleHistoryTaskData.mission_name.slice(0, 11) + '...' : singleHistoryTaskData.mission_name}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    优先级：<img :src="singleHistoryTaskData.priorityIcon" alt="">
                  </div>
                </el-col>
              </el-row>
            </div>
            
            <div class="taskInfoBox taskTime">
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    预计发货时间：<span>{{singleHistoryTaskData.appointment_delivery_at}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    预计收货时间：<span>{{singleHistoryTaskData.appointment_receive_at}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="taskInfoBox shipperInfo">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple shipperInfoTitle">
                    (发送方) 投送信息
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    补堆名称: 
                     <el-tooltip
                      class="item"
                      effect="light"
                      :content="singleHistoryTaskData.customer_company"
                      placement="top"
                      :disabled="singleHistoryTaskData.customer_company.length <= 13"
                    >
                      <span> {{ singleHistoryTaskData.customer_company.length > 13 ?  singleHistoryTaskData.customer_company.slice(0, 13) + '...' : singleHistoryTaskData.customer_company}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    发货地址: 
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="singleHistoryTaskData.customer_address"
                      placement="top"
                      :disabled="singleHistoryTaskData.customer_address.length <= 13"
                    >
                      <span> {{ singleHistoryTaskData.customer_address.length > 13 ?  singleHistoryTaskData.customer_address.slice(0, 13) + '...' : singleHistoryTaskData.customer_address}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    联系人员: 
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="singleHistoryTaskData.customer_name"
                      placement="top"
                      :disabled="singleHistoryTaskData.customer_name.length <= 13"
                    >
                      <span> {{ singleHistoryTaskData.customer_name.length > 13 ?  singleHistoryTaskData.customer_name.slice(0, 13) + '...' : singleHistoryTaskData.customer_name}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    发货战区: 
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="(singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name)"
                      placement="top"
                      :disabled="(singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name).length <= 13"
                    >
                      <span> {{ (singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name).length > 13 ?  (singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name).slice(0, 13) + '...' : (singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name)}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    联系电话: <span>{{ singleHistoryTaskData.customer_phone }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="taskInfoBox consigneeInfo">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple consigneeInfoTitle">
                    (接收方) 投送信息
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    补堆名称: 
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="singleHistoryTaskData.destination_company"
                      placement="top"
                      :disabled="singleHistoryTaskData.destination_company.length <= 13"
                    >
                      <span> {{ singleHistoryTaskData.destination_company.length > 13 ?  singleHistoryTaskData.destination_company.slice(0, 13) + '...' : singleHistoryTaskData.destination_company}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    收货地址: 
                     <el-tooltip
                      class="item"
                      effect="light"
                      :content="singleHistoryTaskData.destination_address"
                      placement="top"
                      :disabled="singleHistoryTaskData.destination_address.length <= 13"
                    >
                      <span> {{ singleHistoryTaskData.destination_address.length > 13 ?  singleHistoryTaskData.destination_address.slice(0, 13) + '...' : singleHistoryTaskData.destination_address}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    联系人员: <span>{{ singleHistoryTaskData.destination_name }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    发货战区: 
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="(singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name)"
                      placement="top"
                      :disabled="(singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name).length <= 13"
                    >
                      <span> {{ (singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name).length > 13 ?  (singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name).slice(0, 13) + '...' : (singleHistoryTaskData.area_name + '/' + singleHistoryTaskData.station_name)}} </span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    联系电话: <span>{{ singleHistoryTaskData.destination_phone}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="taskInfoBox consigneeInfo">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple consigneeInfoTitle">
                    取货
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    指派货勤: <span>{{ singleHistoryTaskData.receiver_name}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    联系电话：<span>{{ singleHistoryTaskData.receiver_phone}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    取货时间: <span>{{ singleHistoryTaskData.receiver_at}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

          </div>
        </div>
        <div class="rightGoods">
          <div class="taskTitle">
            <div class="taskIcon">
              <img :src="goodsIcon" class="icon" />
            </div>
            <div class="taskInfo">
              <div class="descOfNo">
                货物名称：<span>{{ singleHistoryTaskData.goods_name }} </span>
              </div>
              <div class="line"></div>
              <div class="otherTaskInfo">
                <span><i class="el-icon-takeaway-box"></i>件数：{{ singleHistoryTaskData.goods_count }}</span>
                <span><i class="el-icon-s-goods"></i>总重量：{{ singleHistoryTaskData.goods_total_weight + ' kg'}}</span>
              </div>
            </div>
          </div>

          <div class="goodsContent">
            <div class="goodsInfoBox shipperInfo">
              <div class="shipperInfoTitle">
                发货方信息
              </div>

              <div class="shipperInfoTable">
                <el-table
                  class="table"
                  :data="singleHistoryTaskData.goods"
                  height="218"
                  style="width: 100%"
                  ref="commonTable"
                >
                <el-table-column
                  label="序号"
                  width="50"
                  type="index"
                  align="center"
                  :index="indexMethod"
                >
                </el-table-column>
                  <el-table-column
                    v-for="goodsItem in goodsInfoTableColumnLists"
                    :key="goodsItem.prop"
                    :prop="goodsItem.prop"
                    :label="goodsItem.label"
                    :min-width="goodsItem.minWidth"
                    :align="goodsItem.align"
                    :show-overflow-tooltip="goodsItem.showOverflowTooltip"
                  ></el-table-column>
                </el-table>
              </div>
            </div>

            <div class="goodsPlanList">
              <el-collapse accordion @change="getSingleFlightPlanDetailInfo" v-if="singleHistoryTaskData.flights[0]">
                <el-collapse-item  v-for="item of singleHistoryTaskData.flights" :name="item.id" :key="item.id">
                  <template slot="title">
                    <span class="planNoTitle">计划编号: <span class="planNoValue">{{ item.local_id }}</span></span>
                    <span class="creatTimeTitle">创建时间: <span class="creatTimeValue">{{ item.created_at }}</span></span>
                  </template>
                  <div class="detailInfo">
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          开始时间：<span>{{ singleHistoryTaskFlightPlanInfo.start_at }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          结束时间：<span>{{ singleHistoryTaskFlightPlanInfo.end_at }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          实际开始时间：<span>{{ singleHistoryTaskFlightPlanInfo.real_start_at }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          实际结束时间：<span>{{ singleHistoryTaskFlightPlanInfo.real_end_at }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          计划飞行时间：<span>{{ singleHistoryTaskFlightPlanInfo.plan_time + ' min' }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          计划飞行速度：<span>{{ singleHistoryTaskFlightPlanInfo.plan_speed + ' m/h' }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          实际飞行时间：<span>{{ singleHistoryTaskFlightPlanInfo.real_time + ' min' }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          实际飞行速度：<span>{{ singleHistoryTaskFlightPlanInfo.real_speed + ' m/h' }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          规划距离：<span>{{ singleHistoryTaskFlightPlanInfo.total_mileage + ' km' }}</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          实际距离：<span>{{ singleHistoryTaskFlightPlanInfo.real_distance + ' km' }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          平台载重效能：<span>0</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          投送速度效能：<span>0</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          飞行正确性效能效能：<span>0</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          综合效能指标：<span>0</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          单位重量单位距离费用效能：<span>0</span>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          单位重量单位距离时间效能：<span>0</span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div class="noFlightPlan" v-else>
                暂无筹划的飞行计划！
              </div>
              </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import taskIcon from "@/assets/img/home/task.png";
import goodsIcon from "@/assets/img/home/goods.png";
import minimumerIcon from "@/assets/img/home/minimumer.png";
import secondaryerIcon from "@/assets/img/home/secondaryer.png";
import highesterIcon from "@/assets/img/home/highester.png";
import { deepCopy, valueToLabel } from '@/utils/tools.js'
import { taskSatus, secrecyStatus } from '@/common/dictionary.js'

export default {
  name: 'historicalTaskManagement',
  data() {
    return {
      // 注册图片
      taskIcon,
      goodsIcon,
      minimumerIcon,
      secondaryerIcon,
      highesterIcon,

      addPermission: null,
      // 存储搜索信息
      queryForm: {
        name: ''
      },
      // 存储历史任务 表格数据
      historyTaskTableData: [],
      // 定义历史任务各列相关信息
      historyTaskTableColumnLists: [
        {
          prop: "local_id",
          label: "任务编号",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "mission_name",
          label: "任务名称",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "created_at",
          label: "创建时间",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "username",
          label: "提报人",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "department_name",
          label: "提报部门",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "mission_status",
          label: "任务状态",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
      ],
      // 定义模态框发货方信息表格各列相关信息
      goodsInfoTableColumnLists: [
        {
          prop: "local_id",
          label: "货物编号",
          minWidth: "135",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: 'goods_size',
          label: "体积（长*宽*高）/cm",
          minWidth: "160",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "goods_weight",
          label: "重量/kg",
          minWidth: "90",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "goods_attribute",
          label: "属性",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "goods_type_name",
          label: "类型",
          minWidth: "90",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "goods_package_name",
          label: "包装",
          minWidth: "100",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "goods_secrecy_id",
          label: "密级",
          minWidth: "90",
          align: "center",
          showOverflowTooltip: true
        }
      ],
      // 存储单条历史任务信息
      singleHistoryTaskData: {},
      // 存储单条历史任务飞行信息
      singleHistoryTaskFlightPlanInfo: {},
      // 查看详情模态框 显示隐藏
      dialogVisible: false,
      // 判断是否是第一次打开详情模态框
      dialogVisiblefirst: false,
      // 当前页数
      current: 1,
      // 每页显示条数
      size: 6,
      // 总条数
      totalCount: 0
    }
  },
  created() {
    this.query()
  },
  mounted() {
    this.setGutterWidth();
  },
  methods: {
    // 格式序号为 两位数
    indexMethod(index) {
      index = index + 1
      if (Number(index) < 10) {
        return '0' + index
      }
      return index
    },
    // 搜索历史任务信息 - 分页函数 - 每页显示条数改变触发的事件
    handleSizeChange(size) {
      this.size = size;
      this.query();
    },
    // 搜索历史任务信息 - 分页函数 - 页码改变触发的事件
    handleCurrentChange(current) {
      this.current = current;
      this.query();
    },
    // 查询 获取 历史任务信息
    query() {
      this.getRequest(
        "/uav-task-server/mission/getMissionListForHistoryMissionManage.do?"
        + "pagesize=" + this.$data.size 
        + "&currentpage=" + this.$data.current
        + "&keyword=" + this.queryForm.name
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              let copyHistoryTaskList = deepCopy(res.data.list)
              this.$data.historyTaskTableData = valueToLabel('mission_status', copyHistoryTaskList, taskSatus)
            } else {
              this.$data.totalCount = 0;
              this.$data.historyTaskTableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    // 查看单条历史任务详细信息
    seeDetailHandle(row) {
      this.querySingleHistoryTaskDetailInfo(row.id)
    },
    // 查询单条历史任务详细信息
    querySingleHistoryTaskDetailInfo(id) {
      this.getRequest(
          "/uav-task-server/mission/getMissionDetailForHistoryMissionManage.do?missionId=" + id
        ).then((res) => {
          if(res.status === 200) {
            res = res.data
            if (null != res && 0 == res.code) {
              // 定义 tempStore 临时存储任务数据
              let tempStore = deepCopy(res.data)
              // 优先级状态码转图片
              switch(res.data.priority) {
                case 1:
                  tempStore.priorityIcon = minimumerIcon
                  break;
                case 2:
                  tempStore.priorityIcon = secondaryerIcon
                  break;
                case 3:
                  tempStore.priorityIcon = highesterIcon
                  break;
              }
              // 长宽高、属性 格式转换
              for(let i = 0; i < tempStore.goods.length; i++) {
                // 拼接尺寸
                tempStore.goods[i].goods_size = tempStore.goods[i].goods_length + ' * ' + tempStore.goods[i].goods_weight + ' * ' + tempStore.goods[i].goods_height
                // 拼接属性
                tempStore.goods[i].goods_attribute =
                    (tempStore.goods[i].goods_attribute_id === 1 ? '易碎性,' : '')
                  + (tempStore.goods[i].goods_explosible_id === 1 ? '易爆性,' : '')
                  + (tempStore.goods[i].goods_inflammable_id === 1 ? '易燃性,' : '')
                  + (tempStore.goods[i].goods_cautery_id === 1 ? '腐蚀性,' : '')
                // 去掉属性的最后一个逗号
                tempStore.goods[i].goods_attribute = tempStore.goods[i].goods_attribute.slice(0, -1)
              }
              // 密级转换
              valueToLabel('goods_secrecy_id', tempStore.goods, secrecyStatus)
              // 把tempStore 赋值给 单条历史任务数据
              this.singleHistoryTaskData = deepCopy(tempStore)

              this.dialogVisible = true;
              if (!this.dialogVisiblefirst) {
                this.dialogVisiblefirst = true
              }
            }
          }
        })
    },
    // 查询单条历史任务飞行计划详细信息
    getSingleFlightPlanDetailInfo(id) {
      if(id){
        this.getRequest("/uav-task-server/flight/getFlightDetailForFlightManage.do?flightId=" + id)
          .then((res) => {
            if(res.status === 200) {
              res = res.data
              if (null != res && 0 == res.code) {
                this.singleHistoryTaskFlightPlanInfo = deepCopy(res.data)
              }
            }
          })
      }
    },
    // 关闭按钮事件
    closeDetailHandle() {
      this.dialogVisible = false
    }
  }
}
</script>

<style>
  @import "../../../assets/css/admin/historicalTaskManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/admin/management/historicalTaskManagement.vue